import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import StoreSocialMedia$1 from './StoreSocialMedia.js';

const StoreSocialMediaContainer = (_param)=>{
    var { logos =[] , socialMediaLinks =[]  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "logos",
        "socialMediaLinks"
    ]);
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getLabel('stores.page.details.socialMedia.title')
        })
    , [
        getLabel
    ]);
    const items = React__default.useMemo(()=>{
        return socialMediaLinks.map(({ code , url  })=>{
            var ref;
            const logo = logos.find(({ image  })=>{
                return (image === null || image === void 0 ? void 0 : image.description) === code;
            });
            if (!logo) {
                return null;
            }
            return {
                name: code,
                url,
                iconUrl: (ref = logo.image) === null || ref === void 0 ? void 0 : ref.url
            };
        }).filter((item)=>item !== null
        );
    }, [
        logos,
        socialMediaLinks
    ]);
    return items.length > 0 ? /*#__PURE__*/ React__default.createElement(StoreSocialMedia$1, swcHelpers.extends({}, rest, {
        labels: labels,
        items: items
    })) : null;
};
var StoreSocialMedia = StoreSocialMediaContainer;

export { StoreSocialMedia as default };
//# sourceMappingURL=StoreSocialMediaContainer.js.map
